// @flow

import { Component } from '../jsti/core';
import Notifications from '../constants/Notifications';

/**
 * Sticky component for elements which are sticky BEFORE they have reached their initial position
 */
export default class Sticky extends Component {
  #screenHeight: number;
  #offsetTop: number;
  #calcFromTop: boolean;
  #customOffset: number = 0;
  class: string = 'sticky';

  /**
   * Initialize the component
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    this.addListener(Notifications.SCROLL, this.onScroll);

    this.#screenHeight = window.screen.height;
    this.#offsetTop = this.el.offsetTop;
    this.#calcFromTop = (this.el.dataset.fromTop !== undefined);

    const customOffset: number = +this.el.dataset.offset || 0;
    if (customOffset) {
      this.#customOffset = customOffset;
    }

    // On page load, simulate a scroll to set the element to fixed if necessary
    this.onScroll({ scrollTop: 0 });
  }

  /**
   * Check if the element should be sticky
   */
  onScroll({ scrollTop }: Object): void {
    this.el.dataset.width = this.el.offsetWidth;

    let top: boolean = ((scrollTop + this.#screenHeight) < (this.#offsetTop + this.#customOffset));
    if (this.#calcFromTop) {
      top = scrollTop > this.#customOffset;
    }
    if (top) {
      if (this.el.dataset.width) {
        this.el.style.width = this.el.dataset.width.toString() + 'px';
      }
      this.el.classList.add(this.class);
    } else {
      this.el.classList.remove(this.class);
    }
  }
}
